'use client';
import { track } from '@/utils/rudderstack';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

const storedFlagsKey = 'lovevery-storedFlags';

export default function useFeature(flagName: string) {
  const ldClient = useLDClient();
  const [variation, setVariation] = useState<string | boolean | undefined>(
    undefined,
  );

  useEffect(() => {
    const ldVariation = ldClient?.variation(flagName);
    setVariation(ldVariation);
  }, [flagName, ldClient]);

  useEffect(() => {
    const storedFlags = JSON.parse(
      sessionStorage.getItem(storedFlagsKey) || '[]',
    );

    // To control the amount of data sent to amplitude/rudderstack.
    if (variation !== undefined && !storedFlags.includes(flagName)) {
      track('LaunchDarkly Flag Viewed', {
        flag: flagName,
        decision: variation,
      });

      sessionStorage.setItem(
        storedFlagsKey,
        JSON.stringify([...storedFlags, flagName]),
      );
    }
  }, [variation, flagName]);

  return variation;
}
